import { DialogBox } from "@/_component/Common";
import VerifyAssigneeOtp from "./VerifyAssigneeOtp";

export default function AssigneeOtpPopup({onClose, assigneeData, onVerifyOtp}){
    
    return (
        <DialogBox title={"Verify Assignee OTP"} onClose={onClose}>
            <div className="text-center">
                <VerifyAssigneeOtp
                    assigneeData={assigneeData}
                    onVerifyOtp={onVerifyOtp}
                />
            </div>
        </DialogBox>
    );
}